import React from 'react'
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
export default function BarChartsMain({ barcolor, xAxisDataKey, barData, heading, chartFilterValues, setFilters, showFilters = false, yAxisLabel, angelTilt = "-35",heightcustom="252px",xaxis="end" }) {
    const handleWise = (e, type) => {
        setFilters((prev) => ({
            ...prev,
            [type]: e
        }))
    }
    return (
        <>
            <div className='Areachart-box'>
                <div className='topHeader'>
                    <div>
                        <h5 className='text-center' style={{fontSize:'16px'}}><b>{heading}</b></h5>
                    </div>

                    {
                        showFilters ?
                            <div style={{ display: 'flex', gap: '5px' }}>
                                <button className={`customArea-btn ${chartFilterValues?.type == "daily" ? "active" : ""}`} onClick={() => handleWise("daily", "type")}>Daily</button>
                                <button className={`customArea-btn ${chartFilterValues?.type == "weekly" ? "active" : ""}`} onClick={() => handleWise("weekly", "type")}>Weekly</button>
                                <button className={`customArea-btn ${chartFilterValues?.type == "monthly" ? "active" : ""}`} onClick={() => handleWise("monthly", "type")}>Monthly</button>
                            </div>
                            : ""}
                </div>
                <div style={{ width: '100%', height: heightcustom }}>
                    <ResponsiveContainer width="100%" height="100%">
                        <BarChart
                            data={barData}
                            margin={{
                                top: 10,
                                right: 0,
                                left: 0,
                                bottom: 0,
                            }}
                            barCategoryGap="20%"
                        >
                            <CartesianGrid strokeDasharray="3 3" vertical={false} />

                            <XAxis
                                dataKey={xAxisDataKey}
                                angle={angelTilt}
                                textAnchor={xaxis}
                                interval={0}
                                height={60}
                                tickLine={false} axisLine={{ stroke: "#0000001f", strokeWidth: 1 }}
                            />

                            <YAxis
                                tickLine={false} axisLine={{ stroke: "rgba(0, 0, 0,0.12)", strokeWidth: 1 }} />



                            <Bar
                                dataKey={yAxisLabel}
                                fill={barcolor}
                                barSize={35}
                                radius={[8, 8, 0, 0]}
                            />
                            <Tooltip
                                content={<CustomTooltip />}
                                cursor={false}
                            />
                        </BarChart>
                    </ResponsiveContainer>
                </div>

            </div>
        </>
    )
}


const CustomTooltip = ({ active, payload, label }) => {
    if (!active || !payload || !payload.length) return null;

    return (
        <div
            style={{
                background: '#fff',
                border: '1px solid #e0e0e0',
                borderRadius: '6px',
                padding: '8px 12px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                fontSize: '12px'
            }}
        >
            <p style={{ margin: 0, fontWeight: 600 }}>{label}</p>
            <p style={{ margin: '4px 0 0', color: payload[0].fill }}>
                {payload[0].name}: {payload[0].value}
            </p>
        </div>
    );
};
